import FormFieldAPI from './form_field_api';

/**
 * @class LabelFormFieldAPI
 * @extends FormFieldAPI
 */
class CheckboxFormFieldAPI extends FormFieldAPI {

	/**
	 *
	 * @param {*} val
	 */
	value(value) {
		var checked;		
		if (typeof value !== "undefined" && value === "") {
			checked = false;			
			return this.set({ checked: false, value, rawValue: value })
		} else if (value === this.valueWhenChecked()) {
			checked = true;
			return this.set({ value, checked, rawValue: value})
		}

		return this.get("value");
	}

	/**
	 *
	 * @param {*} val
	 */
	checked(val) {
		if (typeof val !== "undefined") {
			let value = val ? this.valueWhenChecked() : null;
			let checked = val;
			return this.set({ value, checked })
		}

		return this.get("checked");
	}
}

export default CheckboxFormFieldAPI;
